import { Calendar, Star } from "lucide-react";
import { Duration } from "../goals/GoalWizard";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

interface DatesStepProps {
    startDate: Date;
    endDate: Date;
    onStartDateChange: (date: Date) => void;
    onEndDateChange: (date: Date) => void;
    duration: Duration;
    startDateLabel?: string;
    endDateLabel?: string;
}

const DatesStep = ({
    startDate,
    endDate,
    onStartDateChange,
    onEndDateChange,
    startDateLabel,
    endDateLabel
}: DatesStepProps) => {
    const { t } = useTranslation();

    return (
        <>
            <h3 className="text-lg font-medium text-gray-900 dark:text-white">
                {t('goals.wizard.dates.title', 'Set your timeline')}
            </h3>
            <div className="grid gap-4">
                <div>
                    <label className=" text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
                        <Calendar className="w-4 h-4 mr-2 text-blue-500" />
                        {startDateLabel || t('goals.wizard.dates.startDate', 'Start date')}
                    </label>
                    <input
                        type="date"
                        value={format(startDate, 'yyyy-MM-dd')}
                        onChange={(e) => onStartDateChange(new Date(e.target.value))}
                        className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                        aria-label={t('goals.wizard.dates.startDate', 'Start date')}
                    />
                </div>
                <div>
                    <label className=" text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
                        <Star className="w-4 h-4 mr-2 text-purple-500" />
                        {endDateLabel || t('goals.wizard.dates.endDate', 'End date')}
                    </label>
                    <input
                        type="date"
                        value={format(endDate, 'yyyy-MM-dd')}
                        onChange={(e) => onEndDateChange(new Date(e.target.value))}
                        className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                        aria-label={t('goals.wizard.dates.endDate', 'End date')}
                    />
                </div>
            </div>
        </>
    );
};

export default DatesStep;